// src/pages/Appointments/Admin/VisitTracking/VisitProgressBar.jsx
import React from "react";
import { FiCheckCircle, FiClock, FiCheck } from "react-icons/fi";

const VisitProgressBar = ({ status }) => {
  const steps = [
    { key: "CHECKED_IN", label: "Checked In", icon: FiCheck },
    { key: "IN_PROGRESS", label: "In Progress", icon: FiClock },
    { key: "COMPLETED", label: "Completed", icon: FiCheckCircle },
  ];

  const getStepStatus = (stepKey) => {
    const statusOrder = ["CHECKED_IN", "IN_PROGRESS", "COMPLETED"];
    const currentIndex = statusOrder.indexOf(status);
    const stepIndex = statusOrder.indexOf(stepKey);

    if (stepIndex < currentIndex) return "completed";
    if (stepIndex === currentIndex) return "active";
    return "pending";
  };

  return (
    <div className="py-4">
      <div className="flex items-center justify-between">
        {steps.map((step, index) => {
          const Icon = step.icon;
          const stepStatus = getStepStatus(step.key);

          return (
            <React.Fragment key={step.key}>
              {/* Step */}
              <div className="flex flex-col items-center">
                <div
                  className={`w-10 h-10 rounded-full flex items-center justify-center transition-all ${
                    stepStatus === "completed"
                      ? "bg-green-500 text-white"
                      : stepStatus === "active"
                      ? "bg-primary text-white animate-pulse"
                      : "bg-gray-200 text-gray-400"
                  }`}
                >
                  <Icon size={20} />
                </div>
                <span
                  className={`text-xs mt-2 ${
                    stepStatus === "active"
                      ? "text-primary font-semibold"
                      : stepStatus === "completed"
                      ? "text-green-600 font-medium"
                      : "text-gray-400"
                  }`}
                >
                  {step.label}
                </span>
              </div>

              {/* Connector Line */}
              {index < steps.length - 1 && (
                <div className="flex-1 h-1 mx-2">
                  <div
                    className={`h-full transition-all ${
                      stepStatus === "completed"
                        ? "bg-green-500"
                        : stepStatus === "active"
                        ? "bg-gradient-to-r from-green-500 to-gray-200"
                        : "bg-gray-200"
                    }`}
                  />
                </div>
              )}
            </React.Fragment>
          );
        })}
      </div>
    </div>
  );
};

export default VisitProgressBar;
